var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.to)?_c('router-link',{staticClass:"line v-align-middle px-4 py-3 highlight d-flex",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('div',{staticClass:"line px-4 py-3 d-flex"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }